var _a, _b, _c, _d, _e;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { SpaceInfoModel } from './types/space-info.interface';
import { SpaceSettingModel } from './types/space-setting.interface';
import { SpaceCapacityModel } from './types/space-capacity.interface';
import { SpacePermissionModel } from './types/space-permission.interface';
import { SpaceApi } from './types/space-api.interface';
let SpaceServiceImpl = class SpaceServiceImpl {
    constructor(_spaceApi, _spaceInfoModel, _spaceCapacityModel, _spaceSettingModel, _spacePermissionModel) {
        this._spaceApi = _spaceApi;
        this._spaceInfoModel = _spaceInfoModel;
        this._spaceCapacityModel = _spaceCapacityModel;
        this._spaceSettingModel = _spaceSettingModel;
        this._spacePermissionModel = _spacePermissionModel;
    }
    get spaceInfo() {
        return this._spaceInfoModel.spaceInfo;
    }
    get spaceCapacity() {
        return this._spaceCapacityModel.spaceCapacity;
    }
    get spaceSetting() {
        return this._spaceSettingModel.spaceSetting;
    }
    get spacePermission() {
        return this._spacePermissionModel.spacePermission;
    }
    async initSpace(spaceId) {
        const data = await this._spaceApi.getSpaceInitApi(spaceId);
        this.updateSpaceInfo({ ...data.space_info });
        this.updateSpaceSetting(data.space_setting);
        this.updateSpaceCapacity(data.space_capacity);
        this.updateSpacePermission(data.space_permission);
        return data;
    }
    updateSpaceAccessTime(spaceId) {
        return this._spaceApi.updateSpaceAccessTimeApi(spaceId);
    }
    updateSpaceInfo(spaceInfo) {
        this._spaceInfoModel.updateSpaceInfo(spaceInfo);
    }
    updateSpaceSetting(spaceSetting) {
        this._spaceSettingModel.updateSpaceSetting(spaceSetting);
    }
    clearSpaceSetting() {
        this._spaceSettingModel.clearSpaceSetting();
    }
    updateSpaceCapacity(spaceCapacity) {
        this._spaceCapacityModel.updateSpaceCapacity(spaceCapacity);
    }
    updateSpacePermission(spacePermission) {
        this._spacePermissionModel.updateSpacePermission(spacePermission);
    }
    updateSpaceSettingLanguage(language) {
        this._spaceSettingModel.updateSpaceSettingLanguage(language);
    }
    getSpaceCapacityByKey(key) {
        return this._spaceCapacityModel.getSpaceCapacityByKey(key);
    }
    subscribeSpaceInfo(callback) {
        return this._spaceInfoModel.subscribeSpaceInfo(callback);
    }
    subscribeSpaceSetting(callback) {
        return this._spaceSettingModel.subscribeSpaceSetting(callback);
    }
    subscribeSpaceCapacity(callback) {
        return this._spaceCapacityModel.subscribeSpaceCapacity(callback);
    }
    subscribeSpacePermission(callback) {
        return this._spacePermissionModel.subscribeSpacePermission(callback);
    }
};
SpaceServiceImpl = __decorate([
    injectable(),
    __param(0, inject(SpaceApi)),
    __param(1, inject(SpaceInfoModel)),
    __param(2, inject(SpaceCapacityModel)),
    __param(3, inject(SpaceSettingModel)),
    __param(4, inject(SpacePermissionModel)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceApi !== "undefined" && SpaceApi) === "function" ? _a : Object, typeof (_b = typeof SpaceInfoModel !== "undefined" && SpaceInfoModel) === "function" ? _b : Object, typeof (_c = typeof SpaceCapacityModel !== "undefined" && SpaceCapacityModel) === "function" ? _c : Object, typeof (_d = typeof SpaceSettingModel !== "undefined" && SpaceSettingModel) === "function" ? _d : Object, typeof (_e = typeof SpacePermissionModel !== "undefined" && SpacePermissionModel) === "function" ? _e : Object])
], SpaceServiceImpl);
export { SpaceServiceImpl };
